import React, { Component } from "react";
import { Bar } from "react-chartjs-2";
import { ListGroup, ListGroupItem, Row, Col } from "reactstrap";
import { connect } from "react-redux";

import CustomLoader from "../../component/CustomLoader/CustomLoader";
import api from "../../config/api";
import rewardSystemActions from "../../redux/rewardSystem/action";
import authActions from "../../redux/auth/action";
import CustomButton from "../../component/CustomButton/CustomButton";
import GradientTextInput from "../../component/GradientTextInput/GradientTextInput";
import "./style.css";
import PageHead from "../../component/pageHead/PageHead";
import {
  formatNumbers,
  isNetworkRequestFailedError,
} from "../../config/helpers";

class Redemption extends Component {
  state = {
    isLoading: false,
  };

  componentDidMount = () => {
    const { dashboard } = this.props;

    if (!dashboard) {
      this.fetchDashboard();
    }

    this.prepareGraph();
  };

  fetchDashboard = async () => {
    const { user, setRedemptionGraphData, setAlertMessage } = this.props;

    try {
      this.setState({ isLoading: true });

      const payload = {
        userName: user.User.UserName,
      };

      const response = await api.getReferralDashboard(payload, user.token);

      setRedemptionGraphData(response.data.result[0]);
      this.prepareGraph();
    } catch (e) {
      setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e) ? this.fetchDashboard : null,
      });
    }

    this.setState({ isLoading: false });
  };

  prepareGraph = () => {
    const { dashboard } = this.props;

    if (dashboard) {
      const ctx = document.getElementById("canvas").getContext("2d");
      const gradientPurple = ctx.createLinearGradient(0, 0, 0, 100);
      gradientPurple.addColorStop(0, "#32385f");
      gradientPurple.addColorStop(1, "#51608b");

      const gradientBlue = ctx.createLinearGradient(0, 0, 0, 100);
      gradientBlue.addColorStop(0, "#336cad");
      gradientBlue.addColorStop(1, "#3a73b0");

      const gradientGreen = ctx.createLinearGradient(0, 0, 0, 100);
      gradientGreen.addColorStop(0, "#7da009");
      gradientGreen.addColorStop(1, "#9dcb1e");

      this.data = {
        labels: ["Amount", "Redeemed", "Balance"],
        datasets: [
          {
            backgroundColor: [gradientPurple, gradientBlue, gradientGreen],
            data: [
              dashboard.TotalAmountEarned,
              dashboard.TotalAmountRedeemed,
              dashboard.TotalNetBalance,
            ],
          },
        ],
      };

      this.setState({});
    }
  };

  handleChange = (e) => {
    const { setRedemptionData } = this.props;

    setRedemptionData({ redemptionCurrency: e.target.value });
  };

  redeem = async (e) => {
    e.preventDefault();

    const { setAlertMessage, user, redemptionCurrency, setRedemptionData } =
      this.props;

    try {
      if (!redemptionCurrency || redemptionCurrency <= 0) {
        throw new Error("Value should be greater than 0");
      }

      this.setState({ isLoading: true });

      const payload = {
        referredBy: user.User.UserName,
        transactionType: 2,
        currentPointRedeemed: redemptionCurrency,
      };

      await api.redemption(payload, user.token);
      setAlertMessage({ type: "success", message: "Successfull!" });
    } catch (error) {
      setAlertMessage({
        message: error.message,
        type: "error",
        onTryAgain: isNetworkRequestFailedError(error)
          ? () => this.redeem(e)
          : null,
      });
    }
    setRedemptionData({ redemptionCurrency: "" });
    this.setState({ isLoading: false });
  };

  render() {
    const { isLoading } = this.state;
    const { redemptionCurrency, dashboard = {} } = this.props;

    return (
      <div>
        <PageHead title="REDEMPTION" containerStyles={{ width: "100%" }} />
        <div className="redemption-graph-container">
          <Bar
            id="canvas"
            data={this.data || {}}
            width={100}
            height={100}
            options={{
              maintainAspectRatio: false,
              tooltips: {
                callbacks: {
                  label: function (tooltipItem, data) {
                    return formatNumbers(tooltipItem.value);
                  },
                },
              },
              legend: {
                display: false,
              },
              scales: {
                yAxes: [
                  {
                    ticks: {
                      maxTicksLimit: 6,
                      callback: (label) => formatNumbers(label),
                    },
                  },
                ],
                xAxes: [
                  {
                    barPercentage: 0.2,
                    categoryPercentage: 1,
                    gridLines: {
                      display: false,
                      color: "rgba(0,0,0,0.4)",
                      lineWidth: 1,
                    },
                    ticks: {
                      fontStyle: "bold",
                      fontSize: 12,
                      fontColor: "blue",
                    },
                  },
                ],
              },
            }}
          />
        </div>
        <div className="redemption-below-chart">
          <p>Total points</p>
          <p>{dashboard.TotalPointsEarned}</p>
        </div>
        <ListGroup className="my-3 redemption-detail-list-container">
          <ListGroupItem className="py-1 px-4 d-flex justify-content-between">
            <p>Amount</p>
            <p>{dashboard.TotalAmountEarned || 0}</p>
          </ListGroupItem>
          <ListGroupItem className="py-1 px-4 d-flex justify-content-between">
            <p>Redeemed</p>
            <p>{dashboard.TotalAmountRedeemed || 0}</p>
          </ListGroupItem>
          <ListGroupItem className="py-1 px-4 d-flex justify-content-between">
            <p>Balance</p>
            <p>{dashboard.TotalNetBalance || 0}</p>
          </ListGroupItem>
          <ListGroupItem className="py-1 px-4 d-flex justify-content-between">
            <p>Total points</p>
            <p>{dashboard.TotalPointsEarned || 0}</p>
          </ListGroupItem>
        </ListGroup>
        <form onSubmit={this.redeem}>
          <ListGroup>
            <ListGroupItem className="redeemed-input-container pb-4">
              <p className="redeemed-text pr-3">Amount to Redeemed</p>
              <GradientTextInput
                placeholder="greater than 0"
                value={redemptionCurrency}
                onChange={this.handleChange}
                mainContainerClasses="redeemed-text-input"
              />
            </ListGroupItem>
          </ListGroup>
          <Row className="my-2 justify-content-center">
            <Col className="p-0" sm={5} md={2}>
              <CustomButton
                type="submit"
                buttonClasses="btn-block"
                buttonText="Redeem"
              />
            </Col>
          </Row>
        </form>
        {isLoading && <CustomLoader text="Please wait" />}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  ...state.rewardSystem.redemption,
});

const mapDispatchToProps = {
  setRedemptionData: rewardSystemActions.setRedemptionData,
  setRedemptionGraphData: rewardSystemActions.setRedemptionGraphData,
  setAlertMessage: authActions.setAlertMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(Redemption);
